module.exports = __webpack_public_path__ + "img/attack_electricball_blue.4376984c.png";